export const SEARCH_DEBOUNCE_MS = 300;

/** Default number of rows displayed per page in DataGrid tables. */
export const PAGE_SIZE = 100;

/** Status colors used in DataGrid status cells across the app. */
export const APPROVED_COLOR = '#0e7a0d';
export const DENIED_COLOR = '#d13438';
export const PENDING_COLOR = '#c4820e';